module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('overlay'), _vm._v(" "), (_vm.isAuthenticated) ? _c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-toolbar', {
    staticClass: "pa-0",
    attrs: {
      "color": "blue-grey",
      "dark": "",
      "fixed": "",
      "app": "",
      "clipped-right": ""
    }
  }, [(_vm.$store.state.user.applications.length > 1) ? _c('v-menu', {
    staticStyle: {
      "z-index": "201"
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }), _vm._v(" "), _c('leftnav')], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "white--text",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "to": "/"
    }
  }, [_c('v-toolbar-title', [_vm._v("Team Portal")])], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$store.state.application))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.search = true
      }
    }
  }, [_c('v-icon', [_vm._v("search")]), _vm._v(" "), (_vm.search) ? _c('search', {
    on: {
      "closed": function($event) {
        _vm.search = false
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v("\n                    Hello, " + _vm._s(_vm.$store.getters.userName) + "!\n                ")]), _vm._v(" "), (_vm.isAuthenticated) ? _c('router-link', {
    staticClass: "v-btn v-btn-flat theme--light primary",
    attrs: {
      "to": "/login"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("Logout")]) : _vm._e()], 1), _vm._v(" "), _c('v-menu', {
    staticClass: "hidden-md-and-up"
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_vm._v("\n                            Hello, " + _vm._s(_vm.$store.getters.userName) + "!\n                        ")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [(_vm.isAuthenticated) ? _c('router-link', {
    staticClass: "theme--light",
    attrs: {
      "to": "/login"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("Logout")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-content', {
    ref: "mainContent",
    attrs: {
      "id": "mainContent"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticClass: "white--text",
    attrs: {
      "color": "blue-grey",
      "app": ""
    }
  }, [_c('span', [_vm._v("Team Portal")]), _vm._v(" "), _c('span', [_vm._v("© 2019")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isAuthenticated) ? _c('v-app', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('h3', [_vm._v("You must be logged in to view this page. Please login "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("here")]), _vm._v(".")], 1)])], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4afccafc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4afccafc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/portalhome/portalhome.vue.html
// module id = 589
// module chunks = 0